import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/index.css'

// ePeople Agent Platform v1.0.0 - Production Ready Deployment
// Initial deployment to S3 + CloudFront

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
// ePeople Agent v1.0.0 - Production Deployment
